import { render } from "./TvmBbTradeValue.vue?vue&type=template&id=5d5692c2&scoped=true"
import script from "./TvmBbTradeValue.vue?vue&type=script&lang=js"
export * from "./TvmBbTradeValue.vue?vue&type=script&lang=js"

import "./TvmBbTradeValue.vue?vue&type=style&index=0&id=5d5692c2&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5692c2"]])

export default __exports__